// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"dca9a48e","116":"e725e7ca","188":"be764928","369":"4ebfc1a9","395":"b645d068","453":"2ee64004","513":"db5377ae","529":"558fbdf4","676":"e7bd16a1","760":"512d5bf0","775":"c5210250"}[chunkId] + ".chunk.js";
};